<template>
    <div class="single-event-side-game opt edit-btn m-0" @click="toggleMenu" v-click-outside="hideMenu" @click.stop>
        <img src="../../assets/Svg/ellipse.svg" alt="" />
        <div class="sub-setting-options edit-event-options" v-if="showMenu">
            <ul class="d-block pb-0">
                <li class="cursor-pointer" @click="openEditBracketPopup(bracket)">
                    <img src="../../assets/Svg/edit-2.svg" alt="edit" />
                    <p>Edit Bracket</p>
                </li>
                <li class="cursor-pointer" @click="deleteSingleBracket(bracket.id)">
                    <img src="../../assets/Svg/trash.svg" alt="delete" />
                    <p>Delete Bracket</p>
                </li>
            </ul>

        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "BracketEllipsis",
    data() {
        return {
            showMenu: false,
            tournamentTeams: [],
        };
    },
    watch: {
        showMenu(newValue) {
            if (newValue) {
                this.$nextTick(() => {
                    const ulElement = this.$refs.subSettingOptions
                        ? this.$refs.subSettingOptions.querySelector("ul")
                        : null;
                    const liCount = ulElement ? ulElement.children.length : 0;

                    if (liCount === 1) {
                        this.dynamicTopValue = "-20px";
                    } else {
                        this.dynamicTopValue = "-100px";
                    }
                });
            }
        },
    },
    computed: {
        dynamicTop() {
            return this.dynamicTopValue;
        },
    },
    props: {
        bracket: {
            type: Object,
            required: true
        },
        association_id: {
            type: Number,
        },
    },
    methods: {
        async getTournamentTeamsForEdit(bracket) {
      this.tournamentTeams = [];


      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/getEligibleTournamentTeamsForEdit?tournament_guid=${bracket.event_tournament.guid}&bracket_id=${bracket.guid}`;
        const response = await axios.get(url);

        if (response.data.statusCode === 200) {
          this.tournamentTeams = response.data.data.teams;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          const elem = this.$refs.closeTournamentLineUpModal;
          if (elem) {
            elem.click();
          }
          this.$router.push({ name: "Teams" });
        } else {
          console.error("Failed to fetch teams:", response.data.message);
        }
      } catch (error) {
        console.error("Failed to fetch teams:", error);
      } finally {
        this.showLoaderSelectedTeams = 0;
        this.isFetchingSelectedTeams = false;
      }
    },
        getLiCount() {
            if (this.$refs.subSettingOptions) {
                const ulElement = this.$refs.subSettingOptions.querySelector("ul");
                return ulElement ? ulElement.children.length : 0;
            }
            return 0;
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        hideMenu() {
            this.showMenu = false;
        },
        async openEditBracketPopup(bracket) {
            await this.getTournamentTeamsForEdit(bracket);
            this.$root.$emit("openEditBracketModal", {
                tournamentTeams: this.tournamentTeams,
                selectedTournamentName: bracket.event_tournament.tournamentName,
                selectedTournamentGuid: bracket.event_tournament.guid,
                selectedBracketName: bracket.bracket_name,
                selectedBracketDescription: bracket.bracket_description,
                selectedBracketTeams: bracket.bracket_teams,
                bracketGuid: bracket.guid,
                association_id: bracket.event_tournament.event.association_id || this.association_id,
                bracketId: bracket.id,
                eventGuid: bracket.event_tournament.event.guid,
            });
        },
        deleteSingleBracket(bracketId) {
            var formData = new FormData();
            formData.append("association_id", this.association_id);
            formData.append("bracket_id", bracketId);

            this.$confirm(
                `About to delete the bracket. Continue ?`,
            ).then(() => {
                this.showLoader = 1
                axios
                    .post(process.env.VUE_APP_API_URL + "tournaments/brackets/deleteSingleBracket", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        if (response.data.statusCode == 200) {
                            this.$root.$emit("refreshBracket");
                        } else if (response.data.statusCode === 404) {
                            this.$alert(response.data.message, 'Error');
                            this.$router.push({ name: "Teams" });
                        }
                    });
            });
        },
    },
};
</script>